
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-new-follow-tracker/[id]",
      function () {
        return require("private-next-pages/instagram-new-follow-tracker/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-new-follow-tracker/[id]"])
      });
    }
  